import axios from "axios";
import Config from "@/config"

export default class AfterSalesService {
  getDocTree(accesstoken, language) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_docTree.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/tree?language=" + language ?? 'en',
        options
      )
      .then(res => res.data);
  }
  getFavorites(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_favorites.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/favorites",
        options
      )
      .then(res => res.data);
  }
  postFavorite(accesstoken, docTreeId) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_favorites.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/favorites?docTreeId=" + docTreeId,
        null,
        options
      )
      .then(res => res.data);
  }
  deleteFavorite(accesstoken, docTreeId) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_delete_favorites.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("afterSales") + "/favorites?docTreeId=" + docTreeId,
        options
      )
      .then(res => res.data);
  }
  getDocuments(accesstoken, docTreeId, distribution) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_documents.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/documents?docTreeId=" + docTreeId + (distribution ? "&distribution=" + distribution : ""),
        options
      )
      .then(res => res.data);
  }
  deleteDocument(accesstoken, documentId, deleteAll) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("afterSales") + "/documents?documentId=" + documentId + "&deleteAll=" + deleteAll,
        options
      )
      .then(res => res.data);
  }
  searchDocuments(accesstoken, filters, pagination) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_search_documents.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
    };
    let params = { 
      page: pagination?.first / pagination?.rows,
      nRows: pagination?.rows,
      filterAttributes: { distribution: "generic_section" },
      orderAttr: "title",
      ascOrDesc: true
    } 

    if(filters.model) params.filterAttributes.model = filters.model;
    if(filters.category) params.filterAttributes.category = filters.category;
    if(filters.title) params.filterAttributes.title = filters.title;
    if(filters.language) params.filterAttributes.lang = filters.language;

    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/documents/search",
        params,
        options
      )
      .then(res => res.data);
  }
  getCategories(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_categories.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/categories",
        options
      )
      .then(res => res.data);
  }
  // downloadDocument(accesstoken, documentId) {
  //   const options = {
  //     headers: { ...Config.headers(accesstoken), ...{} },
  //     responseType: 'blob'
  //   };
  //   return axios
  //     .get(
  //       Config.proxy + Config.url("afterSales") + "/documents/" + documentId,
  //       options
  //     )
  //     .then(res => res);
  // }
  downloadDocument(externalRef) {
    const options = {
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + externalRef,
        options
      )
      .then(res => res);
  }
  getPreviousVersions(accesstoken, domain, category, language, title, docTreeIds) {
    // if(Config.mock) {
    //   if(domain==='STANDARD') {
    //     return axios
    //       .get(
    //         "stubs/afterSales_get_versions_empty.json?t="+new Date().getTime(),
    //       )
    //       .then(res => res.data);
    //   } else {
    //     return axios
    //       .get(
    //         "stubs/afterSales_get_versions.json?t="+new Date().getTime(),
    //       )
    //       .then(res => res.data);
    //   }
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/documents/versions?domain=" + domain + "&category=" + category + "&language=" + language + "&title=" + encodeURIComponent(title) + "&docTreeIds=" + docTreeIds.join(","),
        options
      )
      .then(res => res.data);
  }
  uploadDocument(accesstoken, data, file) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{ 'Content-Type': 'multipart/form-data' } }
    };
    const fd = new FormData();
    Object.entries(data).forEach(([k, v]) => fd.append(k, v == null ? '' : v));
    if(file) {
      fd.append('file', file, file.name);
    }
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/documents",
        fd,
        options
      )
      .then(res => res.data);
  }
  uploadSpDocs(accesstoken, data, pdf, excel) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{ 'Content-Type': 'multipart/form-data' } }
    };
    const fd = new FormData();
    Object.entries(data).forEach(([k, v]) => fd.append(k, v == null ? '' : v));
    fd.append('pdf', pdf, pdf.name);
    if(excel) {
      fd.append('excel', excel, excel.name);
    }
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/spare-parts/docs",
        fd,
        options
      )
      .then(res => res.data);
  }
  uploadSpCatalogue(accesstoken, excel) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{ 'Content-Type': 'multipart/form-data' } }
    };
    const fd = new FormData();
    fd.append('file', excel, excel.name);
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/spare-parts/catalogue",
        fd,
        options
      )
      .then(res => res.data);
  }
  getVisibility(accesstoken, email) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_visibility.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/visibility/" + encodeURIComponent(email),
        options
      )
      .then(res => res.data);
  }
  saveVisibility(accesstoken, email, form) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_post_visibility.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/visibility/" + encodeURIComponent(email) + "?type=" + form.type + "&docTreeKeys=" + form.docTreeKeys.join(",") + (form.price ? "&price=" + form.price : ""),
        null,
        options
      )
      .then(res => res.data);
  }
  getSparePartsDocs(accesstoken, docTreeId) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spDocs.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/spare-parts/docs?docTreeId=" + docTreeId,
        options
      )
      .then(res => res.data);
  }
  getSparePartsComponents(accesstoken, spDocsId, page, language) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spComponents.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/spare-parts/components?spDocsId=" + spDocsId + "&page=" + page + "&language=" + (language ?? 'en'),
        options
      )
      .then(res => res.data);
  }
  getSpCatalogue(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spCatalogue.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/spare-parts/catalogue",
        options
      )
      .then(res => res.data);
  }
  getSpCart(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spCart.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/spare-parts/cart",
        options
      )
      .then(res => res.data);
  }
  putSpCart(accesstoken, code, quantity, comment) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spCart.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("afterSales") + "/spare-parts/cart?code=" + encodeURIComponent(code) + "&quantity=" + quantity + (comment ? "&comment=" + encodeURIComponent(comment) : ""),
        null,
        options
      )
      .then(res => res.data);
  }
  deleteSpCart(accesstoken, code, deleteItem, deleteAll) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spCart.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    if(deleteAll) {
      return axios
        .delete(
          Config.proxy + Config.url("afterSales") + "/spare-parts/cart?deleteAll=true",
          options
        )
        .then(res => res.data);
    }
    return axios
        .delete(
          Config.proxy + Config.url("afterSales") + "/spare-parts/cart?code=" + encodeURIComponent(code) + "&delete=" + deleteItem + "&deleteAll=false",
          options
        )
        .then(res => res.data);
   }
   postSpOrders(accesstoken, data) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_post_spOrders.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/spare-parts/orders",
        data,
        options
      )
      .then(res => res.data);
  }
  getSpOrders(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_spOrders.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/spare-parts/orders",
        options
      )
      .then(res => res.data);
  }
  printSp(accesstoken, spDocsId, page, content, type, price, lang) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/spare-parts/print?spDocsId=" + spDocsId + (page ? "&page=" + page : "") + "&content=" + content + "&type=" + type + "&price=" + price + "&language=" + lang,
        options
      )
      .then(res => res);
  }
  docAuditLog(accesstoken, documentId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/documents/audit-log?documentId=" + documentId,
        null,
        options
      )
      .then(res => res.data);
  }
  patchDocument(accesstoken, documentId, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .patch(
        Config.proxy + Config.url("afterSales") + "/documents/" + documentId,
        data,
        options
      )
      .then(res => res.data);
  }
  postDocsRmSearch(accesstoken, filters, pagination, language) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_post_docsRm_search.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
    };
    let params = { 
      page: pagination?.first / pagination?.rows,
      nRows: pagination?.rows,
      orderAttr: pagination?.orderAttr ?? "numeroMatricola",
      ascOrDesc: pagination?.ascOrDesc == 1,
    } 

    if(filters.serialNumber) params.matricola = filters.serialNumber;
    if(filters.productCode) params.code = filters.productCode;
    
    return axios
      .post(
        Config.proxy + Config.url("afterSales") + "/docs-rm/search?language=" + (language ?? 'en'),
        params,
        options
      )
      .then(res => res.data);
  }
  getDocsRmBom(accesstoken, numeroMatricola, codice, language) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/afterSales_get_docsRm_bom.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("afterSales") + "/docs-rm/bom?numeroMatricola=" + encodeURIComponent(numeroMatricola) + "&codice=" + encodeURIComponent(codice) + "&language=" + (language ?? 'en'),
        options
      )
      .then(res => res.data);
  }

}
